const shopSeq = ({ initData }) => initData.shopSeq
const shopId = ({ initData }) => initData.shopId
const name = ({ initData }) => initData.name
const categoryList = ({ initData }) => initData.categoryList
const enableReward = ({ initData }) => initData.enableReward
const rewardValue = ({ initData }) => initData.rewardValue
const maxRewardPerMonth = ({ initData }) => initData.maxRewardPerMonth
const consignmentCompany = ({ initData }) => initData.consignmentCompany
const paymentSystemType = ({ initData }) => initData.paymentSystemType
const gameName = ({ initData }) => initData.gameName
const enableCart = ({ initData }) => initData.enableCart
const promotionList = ({ homeData }) => homeData.promotionList
const collectionList = ({ homeData }) => homeData.collectionList
const newList = ({ homeData }) => homeData.newList
const isFilledHomeData = (state, getters) =>
  !!getters.newList.length ||
  !!getters.promotionList.length ||
  !!getters.collectionList.length
const category = ({ category }) => category
const requestPossible = state => state.requestPossible
const control = ({ control }) => control
const tag = ({ tag }) => tag

export default {
  shopSeq,
  shopId,
  name,
  categoryList,
  enableReward,
  rewardValue,
  maxRewardPerMonth,
  consignmentCompany,
  paymentSystemType,
  gameName,
  enableCart,
  promotionList,
  collectionList,
  newList,
  isFilledHomeData,
  category,
  requestPossible,
  control,
  tag
}
